if (!window.RtdOfferingTransition) {
  window.RtdOfferingTransition = class RtdOfferingTransition {
    constructor(root) {
      this.root = root;
      this.frame = null;
    }

    shouldAnimate() {
      return (
        this.root?.dataset.enableOfferingTransition === 'true' &&
        !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
      );
    }

    show(items, { animate = true } = {}) {
      const targets = this.normalize(items);
      this.cancelPendingFrame();

      targets.forEach((item) => {
        item.hidden = false;
        item.inert = false;
        item.classList.remove('is-rtd-offering-entering');
      });

      if (!animate || !this.shouldAnimate() || !targets.length) return;

      targets.forEach((item) => item.classList.add('is-rtd-offering-entering'));
      void targets[0].offsetWidth;

      this.frame = window.requestAnimationFrame(() => {
        targets.forEach((item) => item.classList.remove('is-rtd-offering-entering'));
        this.frame = null;
      });
    }

    hide(items) {
      this.cancelPendingFrame();

      this.normalize(items).forEach((item) => {
        item.hidden = true;
        item.inert = true;
        item.classList.remove('is-rtd-offering-entering');
      });
    }

    cancelPendingFrame() {
      if (this.frame === null) return;
      window.cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    normalize(items) {
      if (!items) return [];
      return (items instanceof Element ? [items] : Array.from(items)).filter(Boolean);
    }
  };
}
